import React, { Suspense, lazy } from "react";
import "../../node_modules/@fortawesome/fontawesome-svg-core/styles.css";
import "../styles/css/bootstrap.min.css";
import "aos/dist/aos.css";
import "../styles/css/swiper-bundle.min.css";
import "../components/dashboard/simplefied-filters.css";

import LandingHeader from "../components/trading/LandingHeader.tsx";
import TradingHero from "../components/trading/TradingHero.tsx";
import Footer from "../components/Footer.tsx";
import { LandingSection } from "../components/landing/SectionReveal.tsx";
import { SECTION_IDS } from "../constants/sections.ts";

const ComoFuncionaSection = lazy(
  () => import("../components/landing/sections/ComoFuncionaSection.tsx")
);
const SocialProofSection = lazy(
  () => import("../components/landing/sections/SocialProofSection.tsx")
);
const SinaisSection = lazy(
  () => import("../components/landing/sections/SinaisSection.tsx")
);
const AISection = lazy(
  () => import("../components/landing/sections/AISection.tsx")
);
const DashboardSection = lazy(
  () => import("../components/landing/sections/DashboardSection.tsx")
);
const ResultsSection = lazy(
  () => import("../components/landing/sections/ResultsSection.tsx")
);
const PricingSection = lazy(
  () => import("../components/modules/index/PricingSection.tsx")
);
const TradingTestimonials = lazy(
  () => import("../components/trading/TradingTestimonials.tsx")
);
const TradingFAQ = lazy(() =>
  import("../components/trading/TradingTestimonials.tsx").then((m) => ({
    default: m.TradingFAQ,
  }))
);
const FinalCTASection = lazy(
  () => import("../components/landing/sections/FinalCTASection.tsx")
);

function SectionFallback() {
  return (
    <div className="flex min-h-[160px] items-center justify-center">
      <div className="h-8 w-8 animate-pulse rounded-full border-2 border-tv-border border-t-tv-accent" />
    </div>
  );
}

export default function Home() {
  return (
    <div className="landing-page min-h-screen">
      <LandingHeader />

      <main>
        <LandingSection id={SECTION_IDS.inicio} noPadding>
          <TradingHero />
        </LandingSection>

        <LandingSection id="comunidade-numeros">
          <Suspense fallback={<SectionFallback />}>
            <SocialProofSection />
          </Suspense>
        </LandingSection>

        <LandingSection id={SECTION_IDS.comoFunciona}>
          <Suspense fallback={<SectionFallback />}>
            <ComoFuncionaSection />
          </Suspense>
        </LandingSection>

        <LandingSection id={SECTION_IDS.sinais}>
          <Suspense fallback={<SectionFallback />}>
            <SinaisSection />
          </Suspense>
        </LandingSection>

        <LandingSection id="inteligencia-artificial">
          <Suspense fallback={<SectionFallback />}>
            <AISection />
          </Suspense>
        </LandingSection>

        <LandingSection id="dashboard-preview">
          <Suspense fallback={<SectionFallback />}>
            <DashboardSection />
          </Suspense>
        </LandingSection>

        <LandingSection id={SECTION_IDS.resultados}>
          <Suspense fallback={<SectionFallback />}>
            <ResultsSection />
          </Suspense>
        </LandingSection>

        <LandingSection id={SECTION_IDS.precos}>
          <Suspense fallback={<SectionFallback />}>
            <PricingSection />
          </Suspense>
        </LandingSection>

        <LandingSection id={SECTION_IDS.testemunhos}>
          <Suspense fallback={<SectionFallback />}>
            <TradingTestimonials />
          </Suspense>
        </LandingSection>

        <LandingSection id={SECTION_IDS.faq}>
          <Suspense fallback={<SectionFallback />}>
            <TradingFAQ />
          </Suspense>
        </LandingSection>

        <LandingSection id={SECTION_IDS.comecar}>
          <Suspense fallback={<SectionFallback />}>
            <FinalCTASection />
          </Suspense>
        </LandingSection>
      </main>

      <Footer sectionId={SECTION_IDS.contacto} />
    </div>
  );
}
